import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '@app/services/loading.service';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {

    totalRequests = 0;
    requestsCompleted = 0;

    constructor(private loader: LoadingService) { }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        const skipLoader = request.headers.has('X-Skip-Loader');
        const requestToHandle = skipLoader
            ? request.clone({ headers: request.headers.delete('X-Skip-Loader') })
            : request;

        if (!skipLoader) {
            this.loader.show();
            this.totalRequests++;
        }

        return next.handle(requestToHandle).pipe(
            finalize(() => {
                if (skipLoader) {
                    return;
                }
                this.requestsCompleted++;
                if (this.requestsCompleted === this.totalRequests) {
                    this.totalRequests = 0;
                    this.requestsCompleted = 0;
                    this.loader.hide();
                }
            })
        );
    }
}
